export default "__VITE_ASSET__BAfIewrc__";